export const inpatientJson = {
  title: 'Κοινωνικό Ιστορικό',
  logoPosition: 'right',
  pages: [
    {
      name: 'page1',
      elements: [
        {
          type: 'text',
          name: 'question1',
          title: 'Ονοματεπώνυμο Προσωπικού Ιατρού',
        },
        {
          type: 'text',
          name: 'question2',
          title: 'Τηλέφωνο Επικοινωνίας Προσωπικού Ιατρού',
        },
        {
          type: 'boolean',
          name: 'question3',
          title: 'Εγγραφή σε προσωπικό ιατρό της Στέγης',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'comment',
          name: 'question4',
          title:
            'Παρακολουθείτε από ιατρό διαφορετικής ειδικότητας (ειδικότητα, ονοματεπώνυμο\r\nκαι στοιχεία επικοινωνίας);',
        },
        {
          type: 'radiogroup',
          name: 'question5',
          title: 'Φάρμακα:',
          choices: [
            {
              value: 'Item 1',
              text: 'Αγοράζονται από τους συγγενείς και παραδίνονται στη Στέγη',
            },
            {
              value: 'Item 2',
              text: 'Αγοράζονται από τη Στέγη και επιβαρύνονται οι συγγενείς',
            },
          ],
        },
        {
          type: 'radiogroup',
          name: 'question6',
          title: 'Πανιά:',
          choices: [
            {
              value: 'Item 1',
              text: 'Αγοράζονται από τους συγγενείς και παραδίνονται στη Στέγη',
            },
            {
              value: 'Item 2',
              text: 'Αγοράζονται από τη Στέγη και επιβαρύνονται οι συγγενείς',
            },
          ],
        },
        {
          type: 'radiogroup',
          name: 'question7',
          title: 'Κινητική λειτουργικότητα:',
          choices: [
            {
              value: 'Item 1',
              text: 'Κλινήρης',
            },
            {
              value: 'Item 2',
              text: 'Κινείται με αναπηρικό αμαξίδιο',
            },
            {
              value: 'Item 3',
              text: 'Κινείται με υποβοήθηση (Π ή μπαστούνι)',
            },
            {
              value: 'Item 4',
              text: 'Κινείται κανονικά',
            },
          ],
          showOtherItem: true,
          otherText: 'Άλλο:',
        },
        {
          type: 'comment',
          name: 'question8',
          title:
            'Συνοπτικό-επιγραμματικό ιατρικό ιστορικό για την άντληση πληροφοριών σχετικά\r\nμε εσπευσμένη διακομιδή στο νοσοκομείο',
        },
      ],
      title: 'Πληροφορίες για το Νοσηλευτικό Προσωπικό',
    },
    {
      name: 'page2',
      elements: [
        {
          type: 'comment',
          name: 'question9',
          title: 'Κοινωνικο – οικονομικές συνθήκες της οικογένειας',
        },
        {
          type: 'comment',
          name: 'question10',
          title:
            'Σχέσεις μεταξύ των μελών και είδος επαφής που διατηρεί με την οικογένεια',
        },
      ],
      title: 'Οικογενειακό Ιστορικό',
    },
    {
      name: 'page3',
      elements: [
        {
          type: 'comment',
          name: 'question11',
          title: 'Λόγος εισδοχής;',
        },
        {
          type: 'comment',
          name: 'question12',
          title: 'Ποιος φρόντιζε τον ασθενή πριν την εισδοχή;',
        },
        {
          type: 'comment',
          name: 'question13',
          title: 'Ποιος έκανε την παραπομπή;',
        },
      ],
      title: 'Εικόνα του ασθενή στο παρόν/Παρουσιαζόμενο πρόβλημα',
    },
    {
      name: 'page4',
      elements: [
        {
          type: 'comment',
          name: 'question14',
          title:
            'Ύπαρξη μελών οικογένειας ή συγγενών/ κοινωνικές σχέσεις και δικτύωση',
        },
      ],
      title: 'Συνθήκες στη στέγη',
    },
    {
      name: 'page5',
      elements: [
        {
          type: 'comment',
          name: 'question15',
          title: 'Χρόνιες Παθήσεις / Μολύνσεις',
        },
        {
          type: 'comment',
          name: 'question16',
          title: 'Διαταραχές Διατροφής',
        },
        {
          type: 'comment',
          name: 'question17',
          title: 'Σωματικά Τραύματα',
        },
        {
          type: 'comment',
          name: 'question18',
          title: 'Παράγοντες κινδύνου λόγω οικογενειακού ιατρικού ιστορικού',
        },
        {
          type: 'comment',
          name: 'question19',
          title: 'Φαρμακευτική Αγωγή',
        },
      ],
      title: 'Ιατρικό Ιστορικό',
    },
    {
      name: 'page6',
      elements: [
        {
          type: 'comment',
          name: 'question20',
          title:
            'Ψυχική κατάσταση: εμφάνιση, στάση, συμπεριφορά και επεξεργασία σκέψης',
        },
        {
          type: 'comment',
          name: 'question21',
          title: 'Κατάθλιψη',
        },
        {
          type: 'boolean',
          name: 'question22',
          title: 'Νιώθει λυπημένος/στεναχωρημένος;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question23',
          title: 'Νιώθει αγχωμένος;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question24',
          title: 'Διαταραχές ύπνου/εφιάλτες;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'comment',
          name: 'question25',
          title:
            'Έχει προβλήματα στον ύπνο του; (όνειρα/εφιάλτες, δυσκολεύετε να κοιμηθεί,\r\nξυπνά μέσα στη νύχτα;)',
        },
        {
          type: 'boolean',
          name: 'question26',
          title: 'Μετατραυματικό Στρες',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'comment',
          name: 'question27',
          title:
            'Αναβιώνει (π.χ εφιάλτες, flashbacks) ένα ή περισσότερα τραυματικά γεγονότα;',
        },
        {
          type: 'comment',
          name: 'question28',
          title:
            'Νιώθει ότι δεν μπορεί να θυμηθεί σημαντικά κομμάτια του/των τραυματικού/ων\r\nγεγονότος/των;',
        },
        {
          type: 'comment',
          name: 'question29',
          title: 'Ξεχνά εύκολα;',
        },
        {
          type: 'boolean',
          name: 'question30',
          title: 'Αυτοκτονικότητα',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question31',
          title: 'Σκέφθηκε ποτέ να κάνει κακό στον εαυτό του;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question32',
          title: 'Κάνει συχνές σκέψεις για το θάνατο;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question33',
          title: 'Νιώθει ότι δεν έχει νόημα να ζει;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
        {
          type: 'boolean',
          name: 'question34',
          title: 'Αίσθημα ασφάλειας στη Στέγη;',
          labelTrue: 'Ναί',
          labelFalse: 'Όχι',
        },
      ],
      title: 'Ψυχολογικό Ιστορικό / Αξιολόγηση',
    },
    {
      name: 'page7',
      elements: [
        {
          type: 'comment',
          name: 'question35',
          title: 'Ποιες είναι οι θρησκευτικές και πολιτιστικές συνήθειες του;',
        },
      ],
      title: 'Θρησκευτικές και πολιτιστικές συνήθειες',
    },
    {
      name: 'page8',
      elements: [
        {
          type: 'comment',
          name: 'question36',
          title: 'Ενδιαφέροντα, δεξιότητες, ταλέντα, χόμπυ',
        },
      ],
      title: 'Ενδιαφέρoντα και Δεξιότητες',
    },
    {
      name: 'page9',
      elements: [
        {
          type: 'comment',
          name: 'question37',
          title: 'Ιστορικό διαμονής σε άλλη Ευρωπαϊκή χώρα (υπό ποιο καθεστώς)',
        },
        {
          type: 'comment',
          name: 'question38',
          title: 'Ιστορικό δικαστικών υποθέσεων',
        },
      ],
      title: 'Νομικό Ιστορικό',
    },
    {
      name: 'page10',
      elements: [
        {
          type: 'text',
          name: 'question39',
          title: 'Παρακαλώ περιγράψτε',
        },
      ],
      title: 'Άλλες σημαντικές πληροφορίες',
    },
  ],
  showPageNumbers: true,
};
